export default __webpack_public_path__ + "static/media/edit.a771032e.svg";